import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { SimplesNacionalFormComponent } from './simples-nacional-form.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        SimplesNacionalFormComponent
    ],
    exports: [
        SimplesNacionalFormComponent
    ]
})
export class SimplesNacionalFormModule { }
